module.exports = __webpack_public_path__ + "img/LogoDashboard-33.94a16b29.svg";